// extracted by mini-css-extract-plugin
export default {"frame":"Frame_frame__jFkKn","side_content_wrap":"Frame_side_content_wrap__dG9rc"};